import {
  FETCH_STATUS_SUCCESS,
  FETCH_STATUS_FAIL,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAIL,
  FETCH_COUNTRIES_BEGIN,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAIL,
} from '../actions/types';

const initialState = {
  status: {},
  countries: [],
  messages: [],
  errors: [],
};

const status = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STATUS_SUCCESS:
      return {
        ...state,
        status: action.payload,
        loading: false,
      };
    case FETCH_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: action.payload,
        loading: false,
      };
    case FETCH_MESSAGES_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload.data,
        loading: false,
      };
    case FETCH_COUNTRIES_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default status;
